import { Channel, ChannelPayloadFilter } from "spyne";
import { AppDataTraits } from "traits/app-data-traits";
import { NavigationTraits } from "traits/navigation-traits";
import { BreadcrumbTraits } from "traits/breadcrumb-traits";
import { PageDocsTraits } from "traits/page-docs-traits";
import { LocalStorageTraits } from 'traits/local-storage-traits';

export class ChannelAppRoute extends Channel {
  constructor(name, props = {}) {
    name = "CHANNEL_APP_ROUTE";
    props.traits = AppDataTraits;
    props.sendCachedPayload = true;
    props.cardStateMachine = NavigationTraits.nav$CreateCardStateMachine();
    super(name, props);
  }

  onDeeplinkAndDataReturned(e) {
    const { payload } = e;
    //console.log("PAYLOAD DEEP LINK ",e);
    this.props.data = payload.appData;
    this.props.spyneDocsData = payload.spyneDocsData;
    this.props.codeGenData = payload.codeGenData;

    if (this.props.route$ === undefined) {
      const actionsArr = [
        "CHANNEL_ROUTE_DEEPLINK_EVENT",
        "CHANNEL_ROUTE_CHANGE_EVENT",
      ];

      const routeChangeFilter = new ChannelPayloadFilter({
        propFilters: {
          action: (val) => actionsArr.indexOf(val) >= 0,
        },
      });

      this.props.route$ = this.getChannel("CHANNEL_ROUTE", routeChangeFilter);
      this.props.route$.subscribe(this.onRouteEvent.bind(this));
    }
  }



  onRouteEvent(e) {
    const { payload, srcElement } = e;
    const { routeData, isDeepLink, pathsChanged, pathInnermost } = payload;
    const { isExpanded } = routeData;
    //console.log("ROUTE ACTION ", payload);

    if (isDeepLink){
      LocalStorageTraits.localStorage$SetCallbackPort();
    }

    const { pageId, cardId } = routeData;



    if (pageId==='kb33'){
      const obj = {   "pageId": "blog",
        "section": "frameworks-are-starting-to-ship-knowledge",
        "channel": "ROUTE",
        "eventPreventDefault": "true"}

      this.sendPayloadToRouteChannel(obj);
      return;

    }


    const { pageChanged, pathsRemoved, cardState, previousCardId } =
      this.props.cardStateMachine(payload);

    const cardExistsBool =
      pathInnermost !== "pageId" || pathsRemoved.indexOf("cardId") < 0;
    const isPageEvent = pathsChanged.indexOf("pageId") >= 0 || !cardExistsBool;

    let action = isPageEvent
      ? "CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT"
      : "CHANNEL_APP_ROUTE_CARD_CHANGE_EVENT";

    if (cardState === "minimize") {
      action = "CHANNEL_APP_ROUTE_CARD_MINIMIZE_EVENT";
    } else if (cardState === "crossFade") {
      action = "CHANNEL_APP_ROUTE_CARD_CROSSFADE_EVENT";
    }

    const data = isPageEvent
      ? this.api$GetPage(pageId)
      : this.api$GetCard(pageId, cardId);

    const docsDataItem = PageDocsTraits.pageDocs$GetDataObjByRouteData(
      routeData,
      this.props.spyneDocsData.docsContent,
    );

    const docsBreadcrumbData =
      BreadcrumbTraits.breadcrumb$GetDocsBreadcrumbData(
        payload,
        this.props.spyneDocsData.docsContent,
      );

    const authStateObj = AppDataTraits.api$GetAuthStateFromAuth0AndStripe();
    //authStateObj.successValidated = true;

    this.sendChannelPayload(
      action,
      {
        routeData,
        isExpanded,
        pageChanged,
        authStateObj,
        pathsRemoved,
        cardState,
        previousCardId,
        docsDataItem,
        docsBreadcrumbData,
        data,
        cardExistsBool,
        srcElement,
        isDeepLink,
        pathsChanged,
      },
      srcElement,
    );

    //console.log("DATA IS ", {action,data});

    //if (window.ga) ga('send', 'pageview', location.pathname);
  }

  onRegistered() {
    this.getChannel("CHANNEL_SPYNE_DOCS_DATA").subscribe(
      this.onDeeplinkAndDataReturned.bind(this),
    );
  }

  addRegisteredActions() {
    return [
      "CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT",
      "CHANNEL_APP_ROUTE_CARD_CHANGE_EVENT",
      "CHANNEL_APP_ROUTE_CARD_MINIMIZE_EVENT",
      "CHANNEL_APP_ROUTE_CARD_EXPAND_EVENT",
      "CHANNEL_APP_ROUTE_CARD_CROSSFADE_EVENT",
      "CHANNEL_APP_ROUTE_CARD_REVEAL_EVENT",
      "CHANNEL_APP_ROUTE_CARD_HIDE_EVENT",
    ];
  }

  onViewStreamInfo(obj) {}
}
